/**
 * Layers of the current spread — two-way synced with canvas selection.
 * Ported from the design prototype's spread-editor/panels.jsx.
 */
import type { ComposeStore } from '../../hooks/useComposeStage';
import { IconImage, IconType, IconForward, IconBackward, IconTrash } from './icons';

export function LayersPanel({ store }: { store: ComposeStore }) {
  const { current, selectedEl, setSelectedEl, removeEl, reorderEl, labelFor } = store;
  if (!current) return null;
  const els = [...current.elements].sort((a, b) => b.z - a.z);
  return (
    <div className="panel" data-testid="layers-panel">
      <p className="panel__hint">
        Everything on <strong>{labelFor(current).label}</strong>, top to bottom.
      </p>
      <div className="layers">
        {els.map((el) => (
          <div
            key={el.id}
            className={`layer ${selectedEl === el.id ? 'layer--on' : ''}`}
            onClick={() => setSelectedEl(el.id)}
          >
            <span className="layer__icon">{el.type === 'image' ? <IconImage /> : <IconType />}</span>
            <span className="layer__label">
              {el.type === 'image' ? el.caption || 'image' : (el.text || '').slice(0, 28)}
            </span>
            <span className="layer__tools" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                onClick={() => reorderEl(el.id, 1)}
                title="Bring forward"
                aria-label="Bring forward"
              >
                <IconForward />
                <span className="layer__tool-label">Forward</span>
              </button>
              <button
                type="button"
                onClick={() => reorderEl(el.id, -1)}
                title="Send backward"
                aria-label="Send backward"
              >
                <IconBackward />
                <span className="layer__tool-label">Backward</span>
              </button>
              <button
                type="button"
                className="layer__del"
                onClick={() => removeEl(el.id)}
                title="Delete"
              >
                <IconTrash />
                <span className="layer__tool-label">Delete</span>
              </button>
            </span>
          </div>
        ))}
        {els.length === 0 && (
          <div className="layers__empty">Empty spread. Drag an image or add text.</div>
        )}
      </div>
    </div>
  );
}
